export default function SelecaoEntidadeController($q, $window, $state, promiseTracker, acessoService, authenticationContext, constants) {
  this.trackers = { carregando: promiseTracker() };
  this.entidades = [];

  (() => {
    var promise = acessoService.getAcessosAgrupadosPorEntidade().then((entidades) => {
      if (_.isEmpty(entidades)) {
        return this.irParaSuite();
      };

      this.entidades = entidades;
    });

    this.trackers.carregando.addPromise(promise);
  })();

  this.selecionar = (entidade) => {
    var promise = $state.go('sistema', { entidade: entidade.context });
    this.trackers.carregando.addPromise(promise);
  };

  this.getBrasaoUrl = (entidadeId) => {
    return `${window.___bth.envs.suite.licenses.v1.host}/api-suite/entidade/${entidadeId}/brasao?access_token=${authenticationContext.getAccessToken()}`;
  }

  this.irParaSuite = () => {
    $window.location.href = constants.services.suiteUi.liberacaoLicenca;
    return $q.defer().promise;
  }
}

SelecaoEntidadeController.$inject = [
  '$q',
  '$window',
  'bfcState',
  'promiseTracker',
  'AcessoService',
  'AuthenticationContext',
  'CONSTANTS'
];
